export const getTodosQueryKey = (userId: string) => [userId, 'todos'];
